(() => {
  const section = document.querySelector('.hx-cinema.hx-scroll-trigger');
  if (!section) return;

  section.querySelectorAll('[data-hx-delay]').forEach(el => {
    el.style.transitionDelay = el.getAttribute('data-hx-delay') || '0ms';
  });

  const base = 140;
  const step = 120;
  section.querySelectorAll('[data-hx-stagger]').forEach(el => {
    const i = parseInt(el.getAttribute('data-hx-stagger') || '0', 10);
    el.style.transitionDelay = (base + (i * step)) + 'ms';
  });

  const reveal = () => section.classList.add('hx-inview');

  if (!('IntersectionObserver' in window)) {
    reveal();
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        reveal();
        io.disconnect();
      }
    });
  }, { threshold: 0.18 });

  io.observe(section);
})();
